import type { RoutePermission } from './types';
import { ROUTE_CONFIG } from '$lib/app/config/routes';

export function matchRoutePattern(
	pattern: string,
	actualPath: string
): Record<string, string> | null {
	const patternSegments = pattern.split('/').filter(Boolean);
	const pathSegments = actualPath.split('/').filter(Boolean);

	if (patternSegments.length !== pathSegments.length) {
		return null;
	}

	const params: Record<string, string> = {};

	for (let i = 0; i < patternSegments.length; i++) {
		const patternSegment = patternSegments[i];
		const pathSegment = pathSegments[i];

		if (patternSegment.startsWith('[') && patternSegment.endsWith(']')) {
			const paramName = patternSegment.slice(1, -1);
			params[paramName] = pathSegment;
		} else if (patternSegment !== pathSegment) {
			return null;
		}
	}

	return params;
}

export function findMatchingRouteConfig(
	actualPath: string
): { config: RoutePermission; params: Record<string, string> } | null {
	const routes = Object.entries(ROUTE_CONFIG);

	const exactMatch = routes.find(([configPath]) => configPath === actualPath);
	if (exactMatch) {
		const [, config] = exactMatch;
		return { config, params: {} };
	}

	for (const [configPath, config] of routes) {
		const params = matchRoutePattern(configPath, actualPath);

		if (params !== null) {
			return { config, params };
		}
	}

	return null;
}
